import { useEffect, useState } from "react";
import { Crest } from "./Crest";

const TABS = [
  { id: "leaderboard", label: "Leaderboard" },
  { id: "rounds", label: "Rounds" },
  { id: "clubhouse", label: "Clubhouse" },
  { id: "roster", label: "The Boys" },
  { id: "rules", label: "Our Game" },
];

export const StickyNav = () => {
  const [active, setActive] = useState("leaderboard");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setActive(e.target.id)),
      { rootMargin: "-35% 0px -60% 0px" }
    );
    TABS.forEach((t) => {
      const el = document.getElementById(t.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <header
      className="sticky top-0 z-50 border-b border-cypress-gold/25 bg-cypress-night/95 shadow-[0_4px_20px_rgba(0,0,0,0.5)] backdrop-blur"
      data-testid="sticky-nav"
    >
      <div className="mx-auto flex h-12 max-w-5xl items-center gap-2 px-3 sm:h-14 sm:px-6">
        <button
          type="button"
          data-testid="nav-home-button"
          aria-label="Back to top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex shrink-0 items-center gap-2"
        >
          <Crest className="h-9 w-auto sm:h-10" />
          <span className="hidden text-[11px] font-bold uppercase tracking-[0.25em] text-cypress-cream min-[420px]:inline">
            Cypress Boys
          </span>
        </button>
        <nav className="ml-auto flex items-stretch" aria-label="Page sections">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              data-testid={`nav-tab-${t.id}`}
              onClick={() => document.getElementById(t.id)?.scrollIntoView({ behavior: "smooth" })}
              className={`flex h-12 items-center border-b-2 px-2 text-[10px] font-bold uppercase tracking-[0.12em] transition-colors min-[420px]:px-3 sm:h-14 sm:px-5 sm:text-sm ${
                active === t.id
                  ? "border-cypress-gold text-cypress-gold [text-shadow:0_0_12px_rgba(201,162,39,0.5)]"
                  : "border-transparent text-cypress-cream/50 hover:text-cypress-cream"
              }`}
            >
              {t.label}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
};
